import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { API_BASE_URL } from "../../src/utils/api";

const NewWorkOrder = () => {
  const [formData, setFormData] = useState({
    description: "",
    details: "",
    property_id: "",
    resolved_by: "",
  });

  const navigate = useNavigate(); // For navigation

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.get(`/addWorkOrder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        alert("Work order created successfully!");
        navigate(-1); // Navigate back after successful submission
      } else {
        throw new Error("Failed to create work order");
      }
    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  const handleClose = () => {
    navigate(-1); // Navigate back to the previous page
  };

  return (
    <div className="new-workorder-container">
      <h1>Create New Work Order</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="description">Description:</label>
          <input
            id="description"
            type="text"
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label htmlFor="details">Details:</label>
          <textarea
            id="details"
            name="details"
            value={formData.details}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label htmlFor="property_id">Property ID:</label>
          <input
            id="property_id"
            type="text"
            name="property_id"
            value={formData.property_id}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label htmlFor="resolved_by">Resolved By:</label>
          <input
            id="resolved_by"
            type="text"
            name="resolved_by"
            value={formData.resolved_by}
            onChange={handleChange}
          />
        </div>
        <div className="form-buttons">
          <button type="submit" className="submit-button">
            Create Work Order
          </button>
          <button type="button" className="button" onClick={handleClose}>
            Close Form
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewWorkOrder;
